import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules'; 
import { useTranslation } from 'react-i18next';
// AOS Importları
import AOS from 'aos';
import 'aos/dist/aos.css';

// Swiper stilleri
import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css'; 

// Tüm resim importları
import rodl1 from '../assets/images/rodlimages/rodl1.webp';
import rodl2 from '../assets/images/rodlimages/rodl2.webp';
import rodl3 from '../assets/images/rodlimages/rodl3.png';
import rodl5 from '../assets/images/rodlimages/rodl5.webp'; 
import rodl7 from '../assets/images/rodlimages/rodl7.png';
import rodl8 from '../assets/images/rodlimages/rodl8.png';
import rodl9 from '../assets/images/rodlimages/rodl9.webp';
import rodl11 from '../assets/images/rodlimages/rodl11.png';
import capital from '../assets/images/rodlimages/capital.png';
import sw from '../assets/images/sw/sw.webp';
import sw10 from '../assets/images/sw/sww.png';
import sw3 from '../assets/images/sw/sw.png';
import sw4 from '../assets/images/sw/sw4.webp';
import sw5 from '../assets/images/sw/klass.png';
import sw6 from '../assets/images/sw/image003.png';
import sw7 from '../assets/images/sw/image004.png';
import sw8 from '../assets/images/sw/image005.png';
import sw9 from '../assets/images/sw/image006.png';
import sw11 from '../assets/images/sw/image009.png';
import ahk from '../assets/images/ahk/ahk.webp';
import ahk1 from '../assets/images/ahk/dunya.png';
import ahk2 from '../assets/images/ahk/hurriyet.png';
import ahk3 from '../assets/images/ahk/Milliyet.png';
import ahk4 from '../assets/images/ahk/ahk4.webp';
import ahk5 from '../assets/images/ahk/ahk5.webp';
import ahk6 from '../assets/images/ahk/ahk6.png';
import ahk7 from '../assets/images/ahk/ahk7.png';
import ahk8 from '../assets/images/ahk/samdan.webp';
import alpplas from '../assets/images/alpplas/alpplas.webp';
import alpplas1 from '../assets/images/alpplas/alpplas1.webp';
import alpplas2 from '../assets/images/alpplas/alpplas2.webp';
import alpplas3 from '../assets/images/alpplas/alpplas3.webp';
import alpplas4 from '../assets/images/alpplas/alpplass.png';
import alpplas5 from '../assets/images/alpplas/alpplas5.png';
import alpplas6 from '../assets/images/alpplas/alpplas6.png';
import alpplas7 from '../assets/images/alpplas/alpplas7.png';
import genova from '../assets/images/genova/Cumhuriyet.webp';
import genova1 from '../assets/images/genova/Hello.webp';
import genova2 from '../assets/images/genova/Ekonomist.webp';
import genova3 from '../assets/images/genova/nbekonomi.webp';
import genova4 from '../assets/images/genova/food.webp';
import genova5 from '../assets/images/genova/hello-2.webp';
import genova6 from '../assets/images/genova/Forbes.webp';


const WorksExamples = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);
  
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const projectData = [
    { title: t('genova'), images: [genova, genova1, genova2, genova3, genova4, genova5, genova6] },
    { title: t('swissConsulate'), images: [sw5, sw4, sw3, sw, sw6, sw7, sw8, sw9, sw10, sw11] },
    { title: t('rodl'), images: [rodl1, rodl2, rodl3, rodl5, rodl7, rodl8, rodl9, rodl11, capital] },
    { title: t('ahk'), images: [ahk, ahk1, ahk2, ahk3, ahk4, ahk5, ahk6, ahk7, ahk8] },
    { title: t('alpplas'), images: [alpplas, alpplas1, alpplas2, alpplas3, alpplas4, alpplas5, alpplas6, alpplas7] },
  ];


  const ImageModal = () => {
    if (!isModalOpen || !selectedImage) return null;

    return (
      <div 
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4 transition-opacity duration-300"
        onClick={closeModal}
        aria-modal="true"
        role="dialog"
      >
        <div 
          className="relative max-w-full max-h-full"
          onClick={(e) => e.stopPropagation()}
        >
  
          <button
            onClick={closeModal}
            className="absolute top-2 right-2 text-white text-3xl font-bold p-2 bg-red-700 rounded-full hover:bg-red-800 transition z-50 flex items-center justify-center"
            aria-label="Kapat"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
          <img 
            src={selectedImage} 
            alt="Büyütülmüş Görsel" 
            className="max-w-full max-h-[90vh] object-contain shadow-2xl" 
          />
        </div>
      </div>
    );
  };
  
  return (
    <div className="bg-white min-h-screen">
        
        
        <div className="p-6 text-center mb-14"> 
      
            <div className="px-4 bg-primary p-4 sm:p-6 rounded-t-xl shadow-lg">
                <h2 
                    className="text-xl sm:text-2xl lg:text-2xl font-bold text-center tracking-wide text-white mb-16" 
                    aria-label={t('exampleswork')}
                >
                    {t('exampleswork')}
                </h2>
            </div>
        </div>
        
      
        <div className="p-6 text-center mb-4 rounded-lg -mt-14"> 
        <div 
            className=" mx-auto px-4 md:px-8 bg-white pt-0 -mt-24 sm:-mt-20 md:-mt-24  shadow-lg" 
            data-aos="fade-up" 
        >
           
            <div className="pt-8 lg:pt-16 pb-8 lg:pb-16">
                
                <div className="flex flex-col gap-12">
            
                {projectData.map((project, index) => (
                 
                    <div 
                        key={index} 
                      
                        className="w-full p-2 sm:p-1 bg-white lg:p-2 rounded-lg shadow-lg"
                        data-aos="fade-up" 
                        data-aos-delay={index * 100} 
                    >
                        <h2 className="text-lg sm:text-xl font-bold text-black mb-4 text-start p-4">{project.title}</h2>
                        <Swiper
                            modules={[Pagination, Autoplay]} 
                            spaceBetween={30} 
                            slidesPerView={1}
                            centeredSlides={true}
                            loop={true}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{ clickable: true }}
                            navigation={false} 
                            breakpoints={{
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 40,
                                },
                                1024: {
                                    slidesPerView: 3,
                                    spaceBetween: 50,
                                },
                            }}
                            className="mySwiper"
                        >
                            {project.images.map((image, imageIndex) => (
                                <SwiperSlide key={imageIndex}>
                                    
                                    <div 
                                        className="cursor-pointer group relative overflow-hidden"
                                        onClick={() => openModal(image)} 
                                    >
                                        <img
                                            src={image}
                                            alt={`${project.title} Image ${imageIndex}`}
                                            className="w-full object-cover"
                                           
                                            style={{ height: 'auto', maxHeight: '500px' }} 
                                            loading="lazy"
                                        />
                                   
                                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
                                            <div className="text-white w-10 h-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-2 rounded-full bg-red-700 bg-opacity-70 flex items-center justify-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m-3-3h6" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                ))}
                </div>
            </div>
        </div>
        
        <ImageModal /> 
    </div>
    </div>
  );
};

export default WorksExamples;